import { auto } from '@popperjs/core';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
export default class EventsCalendar {
    constructor() {
        this.section = document.querySelector('.block-events-calendar');

        this.ready();
    }

    initializeTabs() {
        const tabs = this.section.querySelectorAll('.tab');
        const tabContents = this.section.querySelectorAll('.tab-content');

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                tabs.forEach((tab) => {
                    tab.dataset.active = false;
                });

                tab.dataset.active = true;

                tabContents.forEach((tabContent) => {
                    tabContent.dataset.active = false;
                });

                if (tabContents[index].id === tab.dataset.target) {
                    tabContents[index].dataset.active = true;
                }
            });
            tabContents[index].classList.add('hidden');
        });
    }

    initializeSliders() {
        new Swiper(this.section.querySelector('.what-happened'), {
            modules: [Navigation],
            grabCursor: true,
            sliderperView: 1,
            spaceBetween: 24,
            allowTouchMove: true,
            navigation: {
                nextEl: '.slider-button-next-what-happened',
                prevEl: '.slider-button-prev-what-happened',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: auto,
                    spaceBetween: 16,
                },
            },
        });

        new Swiper(this.section.querySelector('.happening-slider'), {
            modules: [Navigation],
            grabCursor: true,
            sliderperView: 1,
            spaceBetween: 24,
            allowTouchMove: true,
            navigation: {
                nextEl: '.slider-button-next-happening',
                prevEl: '.slider-button-prev-happening',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: auto,
                    spaceBetween: 16,
                },
            },
        });

        new Swiper(this.section.querySelector('.next-events-slider'), {
            modules: [Navigation],
            grabCursor: true,
            sliderperView: 1,
            spaceBetween: 24,
            allowTouchMove: true,
            navigation: {
                nextEl: '.slider-button-next-next-events',
                prevEl: '.slider-button-prev-next-events',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: auto,
                    spaceBetween: 16,
                },
            },
        });
    }

    ready() {
        this.initializeSliders();
        this.initializeTabs();

        this.section.querySelectorAll('.like-button').forEach((btn) => {
            const eventId = btn.getAttribute('data-event');
            const isLiked = localStorage.getItem('events')?.includes(eventId);

            if (isLiked) {
                btn.setAttribute('disabled', true);
            } else {
                const handleClick = () => {
                    const url = btn.getAttribute('data-action');

                    fetch(url).then(() => {
                        btn.setAttribute('disabled', true);
                        btn.removeEventListener('click', handleClick);
                        localStorage.setItem('events', (localStorage.getItem('events') ?? '') + `${eventId},`);
                    });
                };

                btn.addEventListener('click', handleClick);
            }
        });
    }
}

if (document.querySelector('.block-events-calendar')) {
    new EventsCalendar();
}
